import { Card } from "react-bootstrap";
import AtalTinkeringLabImg from "../../utils/images/atal-tinkering-lab.jpeg";
import PrimaryWingImg from "../../utils/images/School_Children1.jpg";
import ArtCraftImg from "../../utils/images/School_Children3.jpg";
import sportsImg from "../../utils/images/sports.jpeg";
import "./Courses.css";

import SeniorWingImg from "../../utils/images/School_Students.jpg";
import MiddleWingImg from "../../utils/images/School_Students2.jpg";

import StreasmImg from "../../utils/images/School_Sport4.jpg";

import MusicImg from "../../utils/images/Music.jpg";
import OlympiadImg from "../../utils/images/Olympiad.jpg";

//import FaqAccordion from '../../components/FaqAccordion/FaqAccordion';

const courses = [
  {
    id: 1,
    img: [AtalTinkeringLabImg],
    title: "ATAL TINKERING LAB",
    description: (
      <p>
        Students explore Robotics, Coding, AI, and 3D Printing through creative,
        project-based learning that builds problem-solving skills.
      </p>
    ),
  },
  {
    id: 2,
    img: [sportsImg],
    title: "SPORTS & YOGA",
    description: (
      <div>
        <p>
          Cricket &#9679; Football &#9679; Basketball &#9679; Badminton &#9679;
          Volleyball &#9679; Taekwondo &#9679; Table Tennis &#9679; Chess
          &#9679; Carrom &#9679; Gymnastics
        </p>
        {/* <p>
          Students gain self-empowerment and enlightenment under the guidance of
          qualified Yoga teachers.
        </p> */}
      </div>
    ),
  },
  {
    id: 3,
    img: [ArtCraftImg],
    title: "ART & CRAFT",
    description:
      "Students will engage in various art and craft projects, exploring their creativity through mediums like clay, fabric, sand, paint, and paper.",
  },
  {
    id: 4,
    img: [MusicImg],
    title: "MUSIC & DRAMATICS",
    description:
      "Students are encouraged to develop their public speaking and dramatic skills through elocution, debates, and recitation.",
  },
  {
    id: 5,
    img: [OlympiadImg],
    title: "OLYMPIADS",
    description:
      "Push Boundaries. Olympiads inspire students to think beyond textbooks and excel competitively.",
  },
  {
    id: 6,
    img: [PrimaryWingImg],
    title: "PRIMARY WING (I-V)",
    description: (
      <p>
        English &#9679; Hindi &#9679; Urdu &#9679; Mathematics &#9679; Science
        (IV onwards) &#9679; EVS &#9679; Social Science (IV onwards) &#9679;
        Computer Science (for I to IV) &#9679; GK &#9679; Art & Craft &#9679;
        Dance &#9679; Physical Training &#9679; Yoga
      </p>
    ),
  },
  {
    id: 7,
    img: [MiddleWingImg],
    title: "MIDDLE WING (VI-VIII)",
    description: (
      <p>
        English &#9679; Hindi &#9679; Urdu &#9679; Mathematics &#9679; Computer
        Science &#9679; GK &#9679; Social Science &#9679; Painting &#9679;
        Health and Physical Education &#9679; Yoga
      </p>
    ),
  },
  {
    id: 8,
    img: [SeniorWingImg],
    title: "SENIOR WING (IX & X)",
    description: (
      <p>
        English &#9679; Hindi &#9679; Urdu &#9679; Mathematics &#9679; Science
        &#9679; GK &#9679; Social Science &#9679; Computer &#9679; Art Education
        &#9679; Health and Physical Education &#9679; Yoga
      </p>
    ),
  },
  {
    id: 9,
    img: [StreasmImg],
    title: "STREAMS & SUBJECTS OFFERED (XI-XII)",
    description: (
      <div>
        <p>
          Humanities/Commerce/Science Stream <br /> English &#9679; Political
          Science / Chemistry &#9679; History / Physics &#9679;
          Math/Biology/Physical Education &#9679; Hindi/Urdu
        </p>
      </div>
    ),
  },

  // {
  //     id: 9,
  //     img: [SportCourseImg],
  //     title: 'IQRAA STUDENT COUNCIL (ISU)',
  //     description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam odio eos distinctio ducimus! Modi quaerat dolores illo accusamus maxime cupiditate culpa minus animi repellat autem!'
  // }
];

function Courses() {
  return (
    <div className="courses-page">
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Our Curriculum</h1>
          <p className="text-center w-75">
            IQRAA Public School follows the Uniform System of Assessment per the
            latest CBSE guidelines for consistent evaluation. We also
            incorporate subject enrichment activities to enhance students'
            skills. Our curriculum is designed to nurture each student's unique
            strengths.
          </p>
          {/* <p className='text-center w-75 mb-5'>We believe that every student has the potential to excel and succeed when nurtured in an environment of encouragement and support. Our curriculum not only promotes overall personal growth but also helps students achieve key milestones such as securing admission to prestigious universities and pursuing successful careers.</p>
                <p className='text-center w-75 mb-5'>Our classrooms are equipped with modern educational tools like Smart Class Technology, interactive boards, advanced computing systems, and specialized learning spaces including biology, chemistry, physics, communication, social studies labs, and AV labs. The curriculum aligns with the latest global educational trends and techniques, offering diverse opportunities for practical application, making the learning experience both challenging and rewarding.</p> */}
        </div>
      </header>

      <div className="container py-5">
        <div className="row g-4">
          {courses.map((course) => (
            <div key={course.id} className="col-sm-6">
              <Card className="text-white shadow scale-hover-effect">
                <Card.Img src={course.img} />
                <Card.ImgOverlay className="d-flex flex-column align-items-center justify-content-center p-md-5">
                  <Card.Title className="fs-2 text-danger">
                    {course.title}
                  </Card.Title>
                  <Card.Text className="text-center course-description">
                    {course.description}
                  </Card.Text>
                </Card.ImgOverlay>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {/* <div className='bg-dark text-light py-5'>
            <FaqAccordion />
        </div> */}
    </div>
  );
}

export default Courses;
